












































































































































































































































































import {
  Component, Prop, PropSync, Watch,
} from 'vue-property-decorator';
import { mask } from 'vue-the-mask';
import {
  DocumentRequest, FilesApi, Document, PresignedurlApi,
} from '@compassdigital/foodworks.ts.sdk';
import { mixins } from 'vue-class-component';
import Dropdown from '@/components/Form/Dropdown/index.vue';
import CustomDropdown from '@/components/Form/CustomDropdown/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import SystemModule from '@/store/modules/system';
import AppModule from '@/store/modules/app';
import Dropzone from '@/components/Form/FileUploadForm/Dropzone/index.vue';
import SecondaryButton from '@/components/Buttons/SecondaryButton/index.vue';
import RestaurantAuditForm from '@/components/Form/Partner/RestaurantAuditForm/index.vue';
import UserModule from '@/store/modules/user';
import ToastModule from '@/store/modules/toast';
import Service from '@/util/ServiceUtil';
import { IMarketRestaurantInfo } from '@/interface/marketInfo';
import Axios from 'axios';
import Users from './Data/State';
import PermissionMixin from '../../../../mixins/PermissionMixin';

@Component({
  components: {
    Textfield,
    CustomDropdown,
    Dropdown,
    Dropzone,
    SecondaryButton,
    RestaurantAuditForm,
  },
  directives: { mask },
})
export default class RestaurantInformation extends mixins(PermissionMixin) {
  @Prop({ default: '56px' }) public height!: string;

  @Prop({ default: '531px' }) public width!: string;

  @PropSync('restaurantInfo', {}) restaurantInfoSync!: any;

  @PropSync('documents', {}) document!: any;

  @Prop({}) marketInfo!: any;

  @PropSync('auditFormError', {}) auditFormErr!: boolean;

  @PropSync('cacheRestaurant', {}) cacheRestaurantSync!: IMarketRestaurantInfo;

  public cuisinesArray: any [] = [];

  public auditForm: boolean = false;

  private deliveryPartners = [
    {
      text: 'Doordash',
      value: 'Doordash',
    },
    {
      text: 'Grubhub',
      value: 'Grubhub',
    },
    {
      text: ' Uber Eats',
      value: ' Uber Eats',
    },
    {
      text: 'Postmates',
      value: 'Postmates',
    },
    {
      text: 'Others',
      value: 'Others',
    },
    {
      text: 'None of the above',
      value: 'None of the above',
    },
  ]

  private mobileOperators = [
    {
      text: 'Foodtruck',
      value: 'Foodtruck',
    },
    {
      text: 'Trailer',
      value: 'Trailer',
    },
    {
      text: 'Smoker',
      value: 'Smoker',
    },
    {
      text: 'Catering service',
      value: 'Catering service',
    },
    {
      text: 'Others',
      value: 'Others',
    },
  ]

  private serviceLocation = ['Restaurant location', 'Others'];

  // private documents: Array<DocumentRequest> | null = null;

  private users = Users;

  private valid = true;

  public dialogSync: boolean = false;

  public saving: boolean = false;

  get partnerType() {
    return this.marketInfo.partnerType;
  }

  public onUpload() {
    this.dialogSync = true;
    this.auditForm = true;
  }

  public onBusinessPhoneInput(e: Event): void {
    const value = (e.target as HTMLInputElement).value ?? '';
    const bn = this.restaurantInfoSync?.businessNumber;
    if (bn && bn.phone !== value) {
      this.$set(bn, 'phone', value);
    }
  }

  @Watch('restaurantInfoSync', { deep: true, immediate: true })
  public normalizeEmptyBusinessPhoneDisplay(): void {
    const bn = this.restaurantInfoSync?.businessNumber;
    if (!bn) return;
    const { phone } = bn;
    if (phone === 0
      || phone === null
      || phone === undefined
      || (typeof phone === 'number' && Number.isNaN(phone))
      || phone === '0') {
      this.$set(bn, 'phone', '');
    }
  }

  restaurantNameRules = [(v: any) => !!v || 'Restaurant name is required'];

  foodTruckRules = [(v: any) => !!v || 'FoodTruck name is required'];

  apronRules = [(v: any) => !!v || 'Apron Exchange name is required'];

  partnerTypeRules = [(v: any) => !!v || 'Food Truck name is required'];

  addressRules = [(v: any) => !!v || 'Street Address is required'];

  cityRules = [(v: any) => !!v || 'City is required'];

  seatCapRules = [
    (v: any) => !!v || 'Seating Capacity is required',
    (restaurantInfo: any) => /^([0-9]|[1-9][0-9]|[1-4][0-9][0-9]|500)$/.test(restaurantInfo)
      || 'Max Seating Capacity is 500',
  ];


  zipCodeRules = [
    (v: any) => !!v || 'Zip is required',
    (restaurantInfo: any) => /^[0-9]*$/.test(restaurantInfo) || 'Zip should contain only numbers',
  ];

  stateRules = [(v: any) => !!v || 'State is required'];

  webRules = [
    (website: any) => {
      if (website && website.length > 0 && !(/^\0|(((?:https:\/\/)|(?:http:\/\/)|(?:www\.))?([a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(?:\??)[a-zA-Z0-9\-._?,'/\\+&%$#=~]+))$/.test(website))) {
        return 'Please enter a valid URL';
      }
      return true;
    },
  ];

  numberRules = [
    (phone: any) => {
      const formatMsg = 'Business number must be in the format (123) 456-7890';
      if (typeof phone === 'number' && Number.isNaN(phone)) return formatMsg;
      const raw = phone == null ? '' : String(phone);
      if (!raw) return true;
      if (/[a-zA-Z]/.test(raw)) return formatMsg;
      const digits = raw.replace(/\D/g, '');
      // eslint-disable-next-line
      const invalidChars = raw.replace(/[\d\s()\-]/g, '');
      if (invalidChars.length > 0) return formatMsg;
      if (digits.length === 0) return true;
      if (digits.length !== 10) return formatMsg;
      return true;
    },
  ];

  cuisineRules = [
    (v: any) => {
      if (!v || v.length < 1) {
        return 'Cuisine Type is required';
      }
      return true;
    },
  ];

  deliveryPartnerRules = [
    (v: any) => {
      if (!v || v.length < 1) {
        return 'Delivery Partner is required';
      }
      return true;
    },
  ];

  mobileOperatorsRules = [
    (v: any) => {
      if (!v || v.length < 1) {
        return 'Mobile Operator is required';
      }
      return true;
    },
  ];

  foodPrepLocationRules = [
    (v: any) => {
      if (!v || v.length < 1) {
        return 'Food Prepare Location is required';
      }
      return true;
    },
  ];

  public mounted() {
    this.getItems();
  }

  // private items = CuisineType;
  public async getItems() {
    const cuisines = new Set<string>([...SystemModule.cuisines]);
    // cuisines.add(this.restaurantInfoSync.cuisineTypes);
    // Default sorted cusines
    this.cuisinesArray = [...cuisines];
  }

  public async onDone(documents: any) {
    const doc = documents[0];
    let base64 = doc.base64Encoded.replace(`${doc.type};base64,`, '');
    base64 = base64.replace('data:', '');
    try {
      this.saving = true;
      const presignedApi = new PresignedurlApi(AppModule.apiConfig);
      const response = await presignedApi.presignedUrl(doc.name, doc.type);
      const { data: { preSignedUrl, getUrl } } = response as any;
      await Axios.put(preSignedUrl, doc.file);
      const documentData: DocumentRequest = {
        documentName: doc.name,
        documentType: 'auditForm',
        url: getUrl,
      };
      const api = new FilesApi(AppModule.apiConfig);
      const files = await api.postFile(documentData);
      const { data } = files;
      if (data) {
        this.document = data;
        this.restaurantInfoSync.auditFormId = (data as any).id;
        this.cacheRestaurantSync.auditFormId = this.restaurantInfoSync.auditFormId;
        this.cacheRestaurantSync.businessNumber = this.restaurantInfoSync.businessNumber;
        const { id } = this.restaurantInfoSync;
        if (id) {
          const user = await Service.patchRestaurant(id, this.cacheRestaurantSync);
          if (user.status === 200) {
            this.saving = false;
          } else {
            ToastModule.setToast({
              message: user.errorMessage,
              timeout: 5000,
            });
          }
        }
      }
    } catch (error) {
      //
    }
    this.saving = false;
  }

  get onBoardingPartner() {
    if (UserModule.currentUser && UserModule.currentRole === 'partner_owner') {
      return UserModule.currentUser.id;
    }
    return '';
  }

  get foodPrepareLocation() {
    if (this.restaurantInfoSync.foodPrepLocation === 'Others') {
      return true;
    }
    return false;
  }

  public async onDeleteDocument(document: Document) {
    try {
      this.saving = true;
      const documentID = document.id;
      const api = new FilesApi(AppModule.apiConfig);
      const res = await api.deleteFile(documentID as string);
      if (res.status === 200) {
        this.document = null;
        this.restaurantInfoSync.auditFormId = '';
      }
    } catch (error) {
      const { message } = error.response.data.error;
      ToastModule.setToast({
        message,
        timeout: 5000,
      });
    }
    this.saving = false;
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }
}
